export function globalCookieName() {
	return 'ebert_cookie';
}

export function createSpinner() {
	const spinner = document.createElement('div');
	spinner.className = 'loader page-spinner';
	return spinner;
}
